module.exports = __webpack_public_path__ + "media/images/single100-84b206fc35f27926bd7409ba60b76e90.jpg";